export const constants = {
  INSTRUCTIONS_FOR_FORM: 'form_instructions',
  PARAMS: 'params',
  RESET_QUERY: 'reset_query',
  REFRESH_DATA: 'refresh_data',
  GET_FULL_NAME: (text) => [text?.firstName, text?.middelName, text?.lastName].join(' '),
  PROFILE_STATUS: {
    CANDIDATES: 'candidates',
    TEST: 'test',
    SCREENING: 'screening',
    LEVEL_1: 'level_1',
    LEVEL_2: 'level_2',
    LEVEL_3: 'level_3',
    LEVEL_4: 'level_4',
    MANAGER_ROUND: 'manager_round',
    HR_ROUND: 'hr_round',
    SALARY_DISCUSSION: 'salary_discussion',
    PREE_OWNBORDING: 'pre_ownboarding',
    DOCCUMENT_VERIFY: 'doccument_verify',
    OFFER_GENRATE: 'offer_genrate',
    APPROVAL: 'approval',
    RELEASE_OFFER_LETTER: 'release_offer_letter',
    ACCEPTANCE: 'acceptance',
    HIRED: 'hired',
    JOINING_ON_HOLD: 'joining_on_hold',
  },
  PROFILE_STATUS_TEXT: {
    candidates: 'Candidates',
    TEST: 'test',
    screening: 'Screening',
    level_1: 'Level 1',
    level_2: 'Level 2',
    level_3: 'Level 3',
    level_4: 'Level 4',
    manager_round: 'Manager Round',
    hr_round: 'HR Round',
    salary_discussion: 'Salary Discussion',
    pre_ownboarding: 'Pre Ownboarding',
    doccument_verify: 'Doccument Verify',
    offer_genrate: 'Offer Genrate',
    approval: 'Approval',
    release_offer_letter: 'Release Offer letter',
    acceptance: 'Acceptance',
    hired: 'Hired',
    joining_on_hold: 'Joining On Hold',
  },
  PROFILE_STATUS_OPTIONS: [
    { name: 'Candidates', value: 'candidates' },
    { name: 'Test', value: 'TEST' },
    { name: 'Screening', value: 'screening' },
    { name: 'Level 1', value: 'level_1' },
    { name: 'Level 2', value: 'level_2' },
    { name: 'Level 3', value: 'level_3' },
    { name: 'Level 4', value: 'level_4' },
    { name: 'Manager Round', value: 'manager_round' },
    { name: 'HR Round', value: 'hr_round' },
    { name: 'Salary Discussion', value: 'salary_discussion' },
    { name: 'Pre Ownboarding', value: 'pre_ownboarding' },
    { name: 'Doccument Verify', value: 'doccument_verify' },
    { name: 'Offer Genrate', value: 'offer_genrate' },
    { name: 'Approval', value: 'approval' },
    { name: 'Release Offer letter', value: 'release_offer_letter' },
    { name: 'Acceptance', value: 'acceptance' },
    { name: 'Hired', value: 'hired' },
    { name: 'Joining On Hold', value: 'joining_on_hold' },
  ],
  REPORT_TYPE: {
    personal_details: 'personal_details',
    doccuments: 'doccuments',
    experiance: 'experiance'
  },
  GET_COLOR_FOR_STATUS: {
    Selected: 'green',
    Rejected: 'red',
    Hold: 'yellow',
  },
  JOINING_DATE: {
    name: 'Joining Date',
    value: 'joiningDate',
  },
  PROBATION_END: {
    name: 'Probation End',
    value: 'probationEnd',
  },
  FULL_SCREEN_MODE: 'FULL_SCREEN_MODE',
  IS_FULL_SCREEN_MODE_ON: 'ON',
  IS_FULL_SCREEN_MODE_OFF: 'OFF',
  CANDIDATE_ID: 'candidateId',
  RUN_PAYROLL_STAGE: {
    'leaveAattendance': 'leave-attendance',
    "newJoineesExits": "new-joinees-exits",
    "bonusSalaryRevisions": "bonus-salary-revisions-overtime",
    "reimbursementAdhoc": "reimbursement-adhoc-payment-deduction",
    "salariesOnHold": "salaries-on-hold-arrears",
    "overridePt": "override-pt-esi-tds-lwf",
  },
  stateList: [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Jammu and Kashmir",
    "Ladakh", "Puducherry", "Chandigarh", "Andaman and Nicobar Islands", "Dadra and Nagar Haveli and Daman and Diu"
  ],
  ALL_MONTS: ["January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  LEAD_SOURCES: [
    { name: 'None', value: 'None' },
    { name: 'Linkedin', value: 'Linkedin' },
    { name: 'Facebook', value: 'Facebook' },
    { name: 'Instagram', value: 'Instagram' },
    { name: 'Twitter', value: 'Twitter' },
    { name: 'Google', value: 'Google' },
    { name: 'Other', value: 'Other' },
    { name: 'Upwork', value: 'Upwork' },
    { name: 'Referral', value: 'Referral' },
    { name: 'Direct', value: 'Direct' },
    { name: 'Event', value: 'Event' },
    { name: 'Advertisement', value: 'Advertisement' },
    { name: 'Email Campaign', value: 'Email Campaign' },
    { name: 'Cold Call', value: 'Cold Call' },
    { name: 'Networking', value: 'Networking' },
    { name: 'Webinar', value: 'Webinar' },
    { name: 'Trade Show', value: 'Trade Show' },
    { name: 'Content Marketing', value: 'Content Marketing' },
    { name: 'SEO', value: 'SEO' },
    { name: 'PPC', value: 'PPC' },
    { name: 'Social Media', value: 'Social Media' },
    { name: 'Affiliate Marketing', value: 'Affiliate Marketing' },
    { name: 'Influencer Marketing', value: 'Influencer Marketing' },
    { name: 'Partnership', value: 'Partnership' },
    { name: 'Press Release', value: 'Press Release' },
    { name: 'Podcast', value: 'Podcast' },
    { name: 'Video Marketing', value: 'Video Marketing' },
    { name: 'Blogging', value: 'Blogging' },
    { name: 'Online Reviews', value: 'Online Reviews' },
    { name: 'Customer Referral', value: 'Customer Referral' },
    { name: 'Lead Generation Service', value: 'Lead Generation Service' }
  ],
  LEAD_STATUS: [
    { name: 'None', value: 'None' },
    { name: 'Attempt to Contact', value: 'Attempt to Contact' },
    { name: 'Contacted', value: 'Contacted' },
    { name: 'Contact in Future', value: 'Contact in Future' },
    { name: 'Junk Lead', value: 'Junk Lead' },
    { name: 'Lost Lead', value: 'Lost Lead' },
    { name: 'Not Contacted', value: 'Not Contacted' },
    { name: 'Pre-Qualified', value: 'Pre-Qualified' },
    { name: 'Unqualified', value: 'Unqualified' }
  ],
  INDUSTRIES: [
    'None', 'Technology', 'Finance', 'Healthcare', 'Education', 'Retail', 'Manufacturing', 'Real Estate', 'Hospitality', 'Transportation', 'Construction',
    'Energy', 'Telecommunications', 'Media', 'Entertainment', 'Professional Services', 'Government', 'Non-Profit', 'Agriculture', 'Food and Beverage',
    'Pharmaceuticals', 'Automotive', 'Aerospace', 'Chemicals', 'Biotechnology', 'Logistics', 'E-commerce', 'Insurance', 'Legal', 'Consulting', 'Marketing', 'Advertising',
    'Human Resources', 'Information Technology', 'Research and Development', 'Public Relations', 'Event Management', 'Travel and Tourism', 'Sports and Recreation',
    'Arts and Culture', 'Environmental Services', 'Security Services', 'Telemarketing', 'Call Center Services', 'Data Analytics', 'Cloud Computing', 'Cybersecurity', 'Blockchain', 'Artificial Intelligence', 'Machine Learning', 'Internet of Things',
    'Virtual Reality', 'Augmented Reality', 'Big Data', 'Mobile Applications', 'Web Development', 'Software Development', 'Database Management', 'Network Administration',
    'System Integration', 'IT Consulting', 'Business Process Outsourcing', 'Customer Relationship Management', 'Supply Chain Management', 'Quality Assurance', 'Compliance and Regulatory Affairs'
  ],
  ACCOUNT_TYPES: ['None', 'Customer', 'Partner', 'Vendor', 'Competitor', 'Investor', 'Prospect', 'Other'],
  ACCOUNT_OWNERSHIP: ['None', 'Public', 'Private', 'Government', 'Non-Profit', 'Joint Venture', 'Sole Proprietorship', 'Partnership', 'Corporation', 'Limited Liability Company (LLC)', 'Cooperative', 'Franchise', 'Trust', 'Association', 'Other'],
  RATINGS: ['None', 'Acuired', 'Active', 'Market Failed', 'Project Cancelled', 'Shut Down'],
  CONTACT_ROLES: [
    { name: 'None', value: 'None' },
    { name: 'Developer/Evaluator', value: 'Developer/Evaluator' },
    { name: 'Decision Maker', value: 'Decision Maker' },
    { name: 'Purchaser', value: 'Purchaser' },
    { name: 'Technical Buyer', value: 'Technical Buyer' },
    { name: 'User', value: 'User' },
    { name: 'Influencer', value: 'Influencer' },
    { name: 'Gatekeeper', value: 'Gatekeeper' },
    { name: 'Champion', value: 'Champion' },
    { name: 'Other', value: 'Other' }
  ],
  PRENAME: [
    { name: 'Mr.', value: 'Mr.' },
    { name: 'Ms.', value: 'Ms.' },
    { name: 'Mrs.', value: 'Mrs.' },
    { name: 'Dr.', value: 'Dr.' },
    { name: 'Prof.', value: 'Prof.' }
  ],
  TARGET_TYPES: [
    { name: 'Revenue', value: 'revenue' },
    { name: 'Accounts', value: 'accounts' },
    { name: 'Deals', value: 'deals' },
    { name: 'Leads', value: 'leads' }
  ],
  TARGET_FOR: [
    { name: 'Schedule Interview', value: 'schedule_interview' },
    { name: 'Hire Developer', value: 'hire_developer' },
    { name: 'Engagement Activities', value: 'engagement_activities' },
    { name: 'Training Sessions', value: 'training_sessions' },
    { name: 'Compliance Target', value: 'compliance_target' }
  ],
  BDE_TARGET_TYPES: [
    { name: 'Leads', value: 'leads' },
    { name: 'Contacts', value: 'contacts' },
    { name: 'Accounts', value: 'accounts' },
    { name: 'Deals', value: 'deals' },
    { name: 'Interview Scheduled', value: 'interview_scheduled' },
    { name: 'Developer Deployed', value: 'developer_deployed' }
  ],
  TASK_STATUS: ['Not Started', 'In Progress', 'Completed', 'On Hold', 'Cancelled', 'Deferred', 'Waiting for Response'],
  PRIORITY: ['High', 'Highest', 'Normal', 'Low', 'Lowest'],
  TASK_FOR: ['Leads', 'Contacts', 'Businesses', 'Deals', 'ShortlistedCandidatesForInterview', 'User', 'ContractInterview'],
  DEVELOPER_AVAILABILITY: [
    { name: 'Remote Only', value: 'remote_only' },
    { name: 'Onsite Only', value: 'onsite_only' },
    { name: 'Hybrid', value: 'hybrid' },
    { name: 'Remote/Onsite/Hybrid', value: 'any' }
  ],
};
